import { BitkitButton } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Separator } from '@chakra-ui/react/separator';
import { Text } from '@chakra-ui/react/text';

export type DataTableLoadMoreProps = {
  isLoading?: boolean;
  loadMore: { call: (amount: number) => void; amount: number; totalCount: number };
  rowsLength: number;
};

const DataTableLoadMore = ({ isLoading, loadMore, rowsLength }: DataTableLoadMoreProps) => {
  let loadMoreButtonCount: number | undefined;
  const { amount, totalCount } = loadMore;

  if (totalCount > rowsLength) {
    loadMoreButtonCount = Math.min(amount, totalCount - rowsLength);
  }

  return (
    <Box display="flex" gap={8} alignItems="center">
      <Text color="text/tertiary" textStyle="body/md/regular">
        {rowsLength === totalCount ? `Showing all ${rowsLength} items` : `Showing ${rowsLength} of ${totalCount}`}
      </Text>
      {loadMoreButtonCount && (
        <>
          <Separator h="24" marginLeft="16" orientation="vertical" />
          <BitkitButton
            onClick={() => {
              loadMore.call(loadMoreButtonCount);
            }}
            state={isLoading ? 'loading' : undefined}
            variant="tertiary"
            size="sm"
          >
            {`Load ${loadMoreButtonCount} more`}
          </BitkitButton>
        </>
      )}
    </Box>
  );
};

export default DataTableLoadMore;
